import axios from 'axios';

export const axiosGraphqlInstance = axios.create({
  baseURL: process.env.REACT_APP_SHOPIFY_AXIOS_BASEURL,
  timeout: 3000,
  headers: {
      'X-Shopify-Storefront-Access-Token': process.env.REACT_APP_SHOPIFY_AXIOS_ACCESS_TOKEN,
      'Content-Type' : 'application/json'
  }
});

export const axiosRestInstance = axios.create({
    baseURL: process.env.REACT_APP_NODE_AXIOS_BASEURL,
    timeout: 30000,
});

axiosRestInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('user-token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Set Content-Type based on data type
    if (config.data instanceof FormData) {
      // Remove Content-Type for FormData - axios will set multipart/form-data automatically
      delete config.headers['Content-Type'];
    } else if (!config.headers['Content-Type']) {
      // Set Content-Type to JSON for non-FormData requests
      config.headers['Content-Type'] = 'application/json';
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const axiosRestInstanceForAI = axios.create({
  baseURL: process.env.REACT_APP_NODE_AXIOS_BASEURL,
  timeout: 30000,
});

axiosRestInstanceForAI.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('user-token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Set Content-Type based on data type
    if (config.data instanceof FormData) {
      // Remove Content-Type for FormData - axios will set multipart/form-data automatically
      delete config.headers['Content-Type'];
    } else if (!config.headers['Content-Type']) {
      // Set Content-Type to JSON for non-FormData requests
      config.headers['Content-Type'] = 'application/json';
    }
    return config;
  },
  (error) => Promise.reject(error)
);